import React, { useCallback, useMemo } from "react";
import { EvaluationListItem, ExamType, getExamTypeName } from "service/exam";
import {
    ListCard,
    ListCardIcon,
    ListCardInfo,
    ListCardTools
} from "../../../../../ListCard";
import { Button, Col, Icon, message, Row } from "antd";
import { useHistory } from "react-router-dom";
import moment from "moment";
import UploadFile from "./components/UploadFile";
import styles from "./index.module.scss";
import CopyToClipboard from "react-copy-to-clipboard";
import { useAtomValue } from "jotai";
import { termListAtom } from "../../../../../../../../../service/stores/CommonStore";

interface EvaluationCardProps {
    data: EvaluationListItem;
    onChange: () => void;
}

export default function EvaluationCard({
    data,
    onChange
}: EvaluationCardProps) {
    const history = useHistory();

    const batchList = useAtomValue(termListAtom);

    const batchName = useMemo(() => {
        return batchList.find(item => item.batchNo === data.batchNo)?.batchName;
    }, [data]);

    const onView = useCallback(() => {
        history.push(
            `/exam/evaluation/${data.batchNo}/${data.examId}/${data.courseNo}/${data.courseSeq}`
        );
    }, [data.examId, history]);

    const formatDate = useCallback(
        (dataStr: string) => moment(dataStr).format("MM-DD HH:mm"),
        []
    );

    const textToCopy = useMemo(
        () => `
当前学期：${batchName}
课程名：${data.courseName}
课编号：${data.courseNo}
课序号：${data.courseSeq}
授课老师：${data.mainTeacherName}(${data.mainTeacherNo})`,
        [data]
    );

    return (
        <ListCard title={data.examName}>
            <ListCardInfo>
                <Row
                    className={styles.course}
                    title={`${data.courseName} ${data.courseNo} ${data.courseSeq}`}>
                    <Col span={10}>课程名：{data.courseName}</Col>
                    <Col span={8}>编号：{data.courseNo}</Col>
                    <Col span={6}>序号：{data.courseSeq}</Col>
                </Row>
            </ListCardInfo>

            <ListCardInfo>
                考试日期：{formatDate(data.examStartTime)} -{" "}
                {formatDate(data.examEndTime)}
            </ListCardInfo>

            <ListCardInfo>
                授课老师：{data.mainTeacherName}({data.mainTeacherNo})
            </ListCardInfo>

            <ListCardInfo>
                评价截止日期：{formatDate(data.endTime)}
            </ListCardInfo>

            <ListCardIcon
                variant={data.examType === ExamType.Exam ? "green" : "blue"}>
                {getExamTypeName(data.examType)}
            </ListCardIcon>

            <div className={styles.copy}>
                <CopyToClipboard
                    text={textToCopy}
                    onCopy={() => message.success("已复制到剪贴板")}>
                    <span>
                        <Icon type="copy" /> 复制课程信息
                    </span>
                </CopyToClipboard>
            </div>

            <ListCardTools>
                <Button type="primary" onClick={onView}>
                    查看详情
                </Button>

                <UploadFile
                    evaluationId={data.evaluationId}
                    fileUrl={data.file}
                    onChange={onChange}
                />
            </ListCardTools>
        </ListCard>
    );
}
